// extracted by mini-css-extract-plugin
export default {"subtitulo":"Unidades_subtitulo__uZHjj"};